// @flow

import React, { Component } from 'react';
import { Menu, Header } from 'semantic-grab-ui/src';
import { queryStringFromObject } from 'utils/route-utils';
import { DEFAULT_PAGE_SIZE } from 'config';

type Props = {
  query: Object,
  pathname: string,
  router: Object,
  lastpage: boolean,
  message?: string,
};

type PageItem = {
  content: string | number,
  disabled: boolean,
  to: string,
  active: boolean,
};

const intermediateItems = 3;

export default class Pagination extends Component {
  props: Props;

  pageItem(content: number | string, destinationPage?: number): PageItem {
    const { pathname, query } = this.props;
    const { page = 1, pageSize = DEFAULT_PAGE_SIZE } = query;
    destinationPage = destinationPage || Number(content);

    const item = {
      content,
      disabled: !destinationPage, // disable if content is NaN
      to: '',
      active: Number(page) === destinationPage,
    };

    if (!item.disabled) {
      const newQuery = Object.assign({}, query, { page: destinationPage, pageSize });
      const queryString = queryStringFromObject(newQuery);
      item.to = `${pathname}?${queryString}`;
    }

    return item;
  }

  pagesList() {
    const pages = [];
    const { page: pageStr = 1 } = this.props.query;
    const { lastpage = false } = this.props;
    const page = Number(pageStr);

    // check whether page is a valid number
    if (!page || page <= 0) {
      return pages;
    }

    for (let i = page, total = intermediateItems; i > 0 && total > 0; (i -= 1), (total -= 1)) {
      const pageItem = this.pageItem(i);
      pages.unshift(pageItem);
    }

    if (Number(pages[0].content) !== 1) {
      pages.unshift(this.pageItem('...'));
      pages.unshift(this.pageItem(1));
    }

    if (page !== 1) {
      pages.unshift(this.pageItem('<', page - 1));
    }

    if (!lastpage) {
      pages.push(this.pageItem('>', page + 1));
    }

    return pages;
  }

  handlePageClick = (event: any, data: any) => {
    if (data.active || data.disabled) {
      return;
    }

    this.props.router.push(data.to);
  };

  render() {
    const pages = this.pagesList();
    const { message } = this.props;

    return (
      <div>
        { message && <Header as="h3" textAlign="center">{message}</Header> }
        { pages.length > 0 &&
          <Menu pagination>
            {pages.map(p => {
              return (
                <Menu.Item active={p.active} to={p.to} key={p.content} onClick={this.handlePageClick} disabled={p.disabled}>
                  {p.content}
                </Menu.Item>
              );
            })}
          </Menu>
        }
      </div>
    );
  }
}
